function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M41.63,9.21c-.65,13.04,13.28,15.51,18.67,27.63,12.93,29.06-23.88,46.08-39.23,23.61-6.39-9.35-6.13-28.64,7.17-30.05-.85,8.45-1.15,25.37,12.01,19.25,10.76-5.01-2.61-14.82-5.13-18.88-4.41-7.1-3.76-21.92,6.5-21.57Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Popularity-active.7349c551.svg";
export { SvgComponent as ReactComponent };